export enum SupportTicketPriority {
  HIGH = "HIGH",
  MID = "MID",
  LOW = "LOW",
}
